import { SVGProps } from 'react';

const Quote = ({ props, fill = 'currentColor' }: { props?: SVGProps<SVGSVGElement>; fill?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="57" viewBox="0 0 64 57" fill="none" {...props}>
    <path
      fill={fill}
      d="M26.41 0v13.242c-7.133 1.728-11.567 7.87-11.76 15.546h12.145V57H0V28.788C0 13.242 11.566 2.687 26.41 0Zm37.204 0v13.242c-7.132 1.728-11.566 7.87-11.759 15.546H64V57H37.205V28.788c0-15.546 11.373-26.101 26.41-28.788Z"
    />
  </svg>
);

export default Quote;
